module.exports = __webpack_public_path__ + "img/account_inner.51c727e9.svg";